/**
 * The player's own choice about wheel animation, layered over the OS setting.
 *
 * `prefers-reduced-motion` (see `useReducedMotion`) is the right *default*, but
 * for a game whose animation is the point it can't be the last word: a phone
 * with "Reduce Motion" on — common on iOS, often without the owner realising —
 * would otherwise snap straight to the result with no spin at all. So this is a
 * hard override, persisted like the mute preference:
 *
 * - `null`  — no choice made; follow the system setting.
 * - `true`  — always animate, even if the system asks to reduce motion.
 * - `false` — never animate.
 */

const KEY = 'spoyl.motion';

/** The stored override, or `null` when the player has never set one. */
export function readMotionOverride(): boolean | null {
  try {
    const value = localStorage.getItem(KEY);
    return value === 'on' ? true : value === 'off' ? false : null;
  } catch {
    return null;
  }
}

export function writeMotionOverride(enabled: boolean): void {
  try {
    localStorage.setItem(KEY, enabled ? 'on' : 'off');
  } catch {
    // Preference stays for this session only — no worse than before it existed.
  }
}
